import useSWR from 'swr';
import * as _ from 'lodash';
import { monday } from '../services/monday';

interface MondayContext {
  boardId: number;
  user: {
    id: string;
    isAdmin: boolean;
  };
}

export async function getMondayContext() {
  return (await monday.get('context')).data as MondayContext;
}

export default function useMonday() {
  const { data: mondayContext } = useSWR(
    `/monday-context`,
    async () => {
      const mondayContext = await getMondayContext();

      return mondayContext;
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );

  return {
    mondayContext,
  };
}
